exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".card[data-v-ced9fe32]{box-shadow:0 2px 4px rgba(0,0,0,.1)}.card-header[data-v-ced9fe32]{padding:.75rem 1rem}.card-header h5[data-v-ced9fe32]{margin-bottom:0}.form-group[data-v-ced9fe32]{margin-bottom:.5rem}.form-group label[data-v-ced9fe32]{margin-bottom:.25rem;display:block}.form-group p[data-v-ced9fe32]{margin-bottom:0}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?minimize!./~/vue-loader/lib/style-compiler?{"optionsId":"0","vue":true,"id":"data-v-ced9fe32","scoped":true,"sourceMap":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./App/Components/BudgetPlan/BudgetPlanDetail.vue
// module id = 1090
// module chunks = 0